import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type Building } from 'services'

export interface BuildingPayload {
  displayName: string
  buildingName?: string | null
  room?: string | null
  street?: string | null
  street2?: string | null
  city?: string | null
  state?: string
  zipCode?: string
  legType?: string
  chamber?: string | null
}

export async function createBuilding (payload: BuildingPayload): Promise<HttpResponse<Building>> {
  return await handleHttpRequest(http.post('/api/v1/us/building/', payload))
}

export async function updateBuilding (buildingId: number, payload: BuildingPayload): Promise<HttpResponse<Building>> {
  return await handleHttpRequest(http.put(`/api/v1/us/building/${buildingId}/`, payload))
}

export async function deleteBuilding (buildingId: number): Promise<HttpResponse<null>> {
  return await handleHttpRequest(http.delete(`/api/v1/us/building/${buildingId}/`))
}
